export const EVENTS_SUMMARY_WIDGET_NAMESPACE = 'widget.events-summary'
